export function sumItems(items, num, keyMap, options) {
  const numeric = options && options.numeric;
  const key = keyMap[num];
  if (!key) return 0;
  return (items || []).reduce((total, item) => {
    const value = item ? item[key] : undefined;
    if (numeric) return total + Number(value || 0);
    return value ? total + 1 : total;
  }, 0);
}
